import { Conversation } from "@/types/conversation";
import { AttachmentType } from "@/types/message";

export const SEARCH_FOR = {
  CONTACT: "contact",
  MESSAGE: "message",
} as const;

export type SearchFor = (typeof SEARCH_FOR)[keyof typeof SEARCH_FOR];

export const SORT_OPTION = {
  NEWEST: "newest",
  OLDEST: "oldest",
  DUE_SOONEST: "due_soonest",
  WAITING_OLDEST: "waiting_oldest",
  WAITING_NEWEST: "waiting_newest",
  PRIORITY: "priority",
} as const;

export type InboxSortKey = (typeof SORT_OPTION)[keyof typeof SORT_OPTION];

export interface SelectAllConversationIdsResult {
  ids: string[];
  capped: boolean;
}

export const MAX_BULK_SELECTION = 500;

export interface GetConversationPreviewTextInput {
  conversation: Conversation;
  showFormPreview: boolean;
  hasWaitingApproval?: boolean;
  /** The viewer, so a teammate's attachment is not labelled as theirs. */
  loggedInUserId?: string | null;
}

/** The conversation the viewer had open when it left what their role sees. */
export interface LostConversation {
  contactId: string;
  /** Who has it now, when it went to a teammate. */
  heldByUserId: string | null;
}

export interface MediaReadyPatch {
  attachmentId: string;
  url: string;
  contentType?: string;
  /** What re-hosting settled it as: an embedded post becomes an image or a video. */
  type?: AttachmentType | null;
}
